var map = {
	"./addCollaboratorToGroup.graphql": 3805,
	"./collaborator.graphql": 4738,
	"./createCollaborator.graphql": 2746,
	"./createGroup.graphql": 2705,
	"./deleteCollaborator.graphql": 8087,
	"./deleteGroup.graphql": 4002,
	"./getRolesWorkspacesContentTypes.graphql": 2149,
	"./group.graphql": 7609,
	"./removeCollaboratorFromGroup.graphql": 6313,
	"./resetPassword.graphql": 3486,
	"./searchAlgolia.graphql": 1965,
	"./searchCollaborators.graphql": 9699,
	"./speedboatSearchOpenSearch.graphql": 6459,
	"./updateCollaborator.graphql": 3725,
	"./updateCollaboratorContracts.graphql": 5264,
	"./updateCollaboratorExternalAccess.graphql": 6394,
	"./updateCollaboratorPermissions.graphql": 4569,
	"./updateCollaboratorResource.graphql": 577,
	"./updateCollaboratorRestriction.graphql": 9643,
	"./updateCollaboratorRoles.graphql": 4254,
	"./updateCollaboratorWorkspaces.graphql": 7575,
	"./updateGroup.graphql": 6564,
	"./updateGroupPermissions.graphql": 2374,
	"./updateGroupRestriction.graphql": 5544,
	"./updateGroupRoles.graphql": 2333,
	"./updateGroupWorkspaces.graphql": 5298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6415;